import { match } from 'ts-pattern';

import { BaseMapper } from '@ps/utils';
import { HealthCheckStatusKey } from '@ps/survey-kernel';
import { SurveyHealthMetric } from '@ps/survey-utils';

import { SurveyHealthDto } from '../dtos/survey-health.dto';

const STATUS_TEXT_LOOKUP: Record<string, HealthCheckStatusKey> = {
  RED: 'RED',
  YELLOW: 'YELLOW',
  GREEN: 'GREEN',
  GREY: 'GREY',
};

// The backend splits recommendations into a yellow-specific and a
// red-specific list; only one is ever relevant for a given metric, so the
// mapper resolves that branch once here instead of the template re-deriving
// it from statusText on every render.
function resolveRecommendations(
  statusText: HealthCheckStatusKey,
  dto: SurveyHealthDto,
): readonly string[] {
  return match(statusText)
    .with('RED', () => dto.rRecommendationMsg)
    .with('YELLOW', () => dto.yRecommendationMsg)
    .otherwise(() => []);
}

export class SurveyHealthMapper extends BaseMapper<
  SurveyHealthDto,
  SurveyHealthMetric
> {
  public fromDto(dto: SurveyHealthDto): SurveyHealthMetric {
    const statusText = STATUS_TEXT_LOOKUP[dto.statusText] ?? 'GREY';

    return {
      kpi: dto.kpi,
      name: dto.name,
      statusText,
      value: dto.value,
      tooltip: dto.tooltip,
      reason: dto.reasonMsg,
      recommendations: resolveRecommendations(statusText, dto),
      nextCalculationTs: dto.nextCalculationTs,
    };
  }
}
